import { useState, useEffect } from 'react'
import HealthService from 'service/HealthService'
import { IHealthLocationList } from 'types/HealthType'

export default function useGetLocationList() {
  const [data, updateData] = useState<IHealthLocationList[]>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function fetchData() {
    setIsLoading(true)
    HealthService.getLocations()
      .then((r) => updateData(r.data))
      .catch((err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [])

  return { data, isLoading, error }
}
